var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVendorTerms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 312.33,
    height: 187.459,
    viewBox: "0 0 312.33 187.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12684",
    d: "M323.35 576.005a1.222 1.222 0 0 1-.885-2.118l.084-.333-.033-.08a3.281 3.281 0 0 0-6.052.022c-.99 2.384-2.25 4.772-2.56 7.293a9.706 9.706 0 0 0 .17 3.338 38.915 38.915 0 0 1-3.54-16.163 37.553 37.553 0 0 1 .233-4.19q.193-1.711.536-3.4a39.366 39.366 0 0 1 7.807-16.684 10.477 10.477 0 0 0 4.357-4.521 7.992 7.992 0 0 0 .727-2.184 9.862 9.862 0 0 1-.64-3.4c-.3-.449-.825-.672-1.148-1.109-1.606-2.177-3.818-1.8-4.973 1.161-2.467 1.245-2.491 3.31-.977 5.3.963 1.263 1.1 2.973 1.94 4.326-.087.111-.177.219-.264.33a39.622 39.622 0 0 0-4.132 6.551 16.47 16.47 0 0 0-.983-7.65c-.941-2.271-2.705-4.183-4.259-6.146a3.381 3.381 0 0 0-6.021 1.66l-.009.087q.346.2.678.415a1.657 1.657 0 0 1-.668 3.016l-.034.005a16.486 16.486 0 0 0 .435 2.465c-1.993 7.707 2.31 10.515 8.453 10.641.136.07.268.139.4.205a40.438 40.438 0 0 0-2.177 10.244 38.353 38.353 0 0 0 .028 6.193l-.01-.073a10.135 10.135 0 0 0-3.46-5.852c-2.663-2.187-6.424-2.993-9.3-4.751a1.9 1.9 0 0 0-2.913 1.85l.012.077a11.134 11.134 0 0 1 1.248.6q.346.2.678.415a1.657 1.657 0 0 1-.668 3.016l-.034.005-.07.01a16.5 16.5 0 0 0 3.036 4.754c1.246 6.728 6.6 7.367 12.324 5.407a40.427 40.427 0 0 0 2.716 7.928h9.7c.035-.108.066-.219.1-.327a11.024 11.024 0 0 1-2.685-.16c.72-.883 1.44-1.773 2.159-2.657a.6.6 0 0 0 .045-.052c.365-.452.734-.9 1.1-1.353a16.147 16.147 0 0 0-.473-4.113z",
    transform: "translate(-270.939 -397.565)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12685",
    d: "M825.784 576.005a1.222 1.222 0 0 0 .885-2.118l-.084-.333.033-.08a3.281 3.281 0 0 1 6.052.022c.99 2.384 2.25 4.772 2.56 7.293a9.707 9.707 0 0 1-.17 3.338 38.915 38.915 0 0 0 3.54-16.163 37.56 37.56 0 0 0-.233-4.19q-.193-1.711-.536-3.4a39.365 39.365 0 0 0-7.807-16.684 10.477 10.477 0 0 1-4.357-4.521 7.991 7.991 0 0 1-.727-2.184 9.863 9.863 0 0 0 .64-3.4c.3-.449.825-.672 1.148-1.109 1.606-2.177 3.818-1.8 4.973 1.161 2.467 1.245 2.491 3.31.977 5.3-.963 1.263-1.1 2.973-1.94 4.326.087.111.177.219.264.33a39.62 39.62 0 0 1 4.135 6.551 16.471 16.471 0 0 1 .983-7.65c.941-2.271 2.705-4.183 4.259-6.146a3.381 3.381 0 0 1 6.021 1.66l.009.087q-.346.2-.678.415a1.657 1.657 0 0 0 .668 3.016l.034.005A16.5 16.5 0 0 1 846 544c1.993 7.707-2.31 10.515-8.453 10.641-.136.07-.268.139-.4.205a40.443 40.443 0 0 1 2.177 10.244 38.372 38.372 0 0 1-.028 6.193l.01-.073a10.136 10.136 0 0 1 3.46-5.852c2.663-2.187 6.424-2.993 9.3-4.751a1.9 1.9 0 0 1 2.913 1.85l-.012.077a11.138 11.138 0 0 0-1.248.6q-.346.2-.678.415a1.657 1.657 0 0 0 .668 3.016l.034.005.07.01a16.5 16.5 0 0 1-3.036 4.754c-1.246 6.728-6.6 7.367-12.324 5.407a40.426 40.426 0 0 1-2.716 7.928h-9.7c-.035-.108-.066-.219-.1-.327a11.024 11.024 0 0 0 2.685-.16c-.72-.883-1.44-1.773-2.159-2.657a.592.592 0 0 1-.045-.052c-.365-.452-.734-.9-1.1-1.353a16.146 16.146 0 0 1 .473-4.113z",
    transform: "translate(-570.734 -397.565)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12686",
    d: "M386.895 411.16h15.656c2.678-9.016.014-30.323 3.544-39.031 6.771-16.7 15.421-34.317 31.567-42.47a47.427 47.427 0 0 1 22.086-4.767c10.6.1 21.506 2.947 31.487 6.719 4.083 1.54 8.129 3.233 12.158 4.963 15.182 6.524 30.2 13.629 46.525 15.55 20.659 2.428 44.95-6.815 50.592-26.724 4.307-15.243-3.449-31.068-11.583-44.681s-17.226-28.179-15.741-43.941c.005-.053.011-.111.021-.164.559-5.661 3.939-9.73 8.661-12.338h-20.559c-.271 14.7 8.235 27.682 15.89 40.5 8.134 13.608 15.89 29.439 11.583 44.681-5.643 19.9-52.366-3.428-73.026-5.861-5.834-.683 3.433 1.746-2.129 0-8.725-2.735-9.692 22.353-18.183 18.671-5.286-2.3-10.577-4.577-15.938-6.6-2.22-.841-4.488-1.63-6.782-2.36-.005 0-.005 0-.011-.005-15.405-4.878-32.254-6.778-46.488.275l-.293.143c-16.145 8.148-24.8 25.767-31.567 42.465-5.593 13.795-4.713 40.415-7.47 54.975z",
    transform: "translate(-323.325 -224.275)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2932",
    cx: 71.905,
    cy: 71.905,
    r: 71.905,
    transform: "translate(78.766 42.613)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12687",
    d: "M492.212 465.162c-71.143 1.635-72.7-32.165-72.7-72.367a72.908 72.908 0 0 1 145.816 0c-.003 40.205-32.915 72.367-73.116 72.367zm.205-143.268c-39.1 0-70.244 31.812-70.9 70.9-.612 36.358 38.012 81.728 70.9 70.9 17.638-19.425 67.5-40.347 70.9-70.9 4.32-38.855-31.806-70.9-70.9-70.9z",
    transform: "translate(-341.746 -278.277)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12688",
    d: "M528.658 476.268a8 8 0 0 1-6.4-3.2l-19.617-26.156a8 8 0 0 1 12.8-9.6l12.834 17.111 32.962-49.443a8 8 0 1 1 13.31 8.874l-39.234 58.851a8 8 0 0 1-6.433 3.559z",
    transform: "translate(-387.796 -324.326)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12689",
    d: "M240.825 653.156a.516.516 0 0 0 .518.518h311.294a.518.518 0 1 0 0-1.036H241.343a.516.516 0 0 0-.518.518z",
    transform: "translate(-240.825 -466.215)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12690",
    d: "M443.657 396.81h-4.21l-2-16.24h6.214z",
    transform: "translate(-247.069 -214.946)",
    style: {
      fill: "#ffb6b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12691",
    d: "M676.083 643.173h-12.948v-.164a5.04 5.04 0 0 1 5.039-5.039l2.365-1.794 4.413 1.794h1.13z",
    transform: "translate(-479.346 -456.917)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12692",
    d: "m394.138 352.17-3.889 1.613-8.072-14.234 5.74-2.38z",
    transform: "translate(-215.854 -190.433)",
    style: {
      fill: "#ffb6b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12693",
    d: "m638.563 598.868-11.96 4.959-.063-.151a5.04 5.04 0 0 1 2.725-6.585l1.5-2.563 4.763-.033 1.044-.433z",
    transform: "translate(-458.459 -433.131)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12694",
    d: "m641.678 429.884-29.88 3.122-4 13.462-13.842 22.244s9.659 16.257 8.752 16.079.906 4.254 2.175 4 2.59 2.632 1.712 3.146 2.644 4.857 2.644 4.857l5.382-4.831c1.145-8.635-.238-16.321-5.166-22.675l15.421-16.648 2.924-1.213 2.321 61.775 8.585.141c2.369-12.186 3.559-23.154 1.707-30.978 0 0 .266-23.5 1.281-23.248s.155-2.805.155-2.805-.889-2.608.2-3.69.41-7.445.41-7.445c1.812-6.022 1.269-10.994-.781-15.293z",
    transform: "translate(-440.275 -340.403)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12695",
    d: "m639.5 306.053 8.26-2.141 3.856-5.318 9.157 1.126 1.949 7.254 6.519 3.784s-3.6 38.111-2.746 40.2 3.93 1.92 1.306 4.617-2.972 1.611-2.363 4.548 5.049 6.045 0 6.014-35.513-.466-34.642-3.948.857-2.6 2.169-4.78 2.2-.963 1.754-4.184a37.724 37.724 0 0 1-.006-7.138c0-1.741 1.458-17.56 1.458-17.56z",
    transform: "translate(-461.069 -266.251)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2933",
    cx: 9.704,
    cy: 9.704,
    r: 9.704,
    transform: "translate(185.396 11.953)",
    style: {
      fill: "#ffb6b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12696",
    d: "M665.761 252.032c.852.689.657 4.037 1.606 3.491s1.147-1.523 2.24-1.534a3.58 3.58 0 0 1 2.357 1.067c.116.105.227.215.335.324.1-.034.2-.066.3-.091a3.083 3.083 0 0 1 2.261.318 3.025 3.025 0 0 0-1.722.695c.209.234.42.469.643.686 1.859 1.821 5.669-.118 8.231-.556-2.134 2.33-1.713 3.631-1.183 6.745v.17c.109-.718 2.409-.682 2.03.271a12.251 12.251 0 0 1-1.773 2.606c3.134-2.171 5.664-5.164 6.224-8.78a5.313 5.313 0 0 0 .122-2.277 1.746 1.746 0 0 0-1.668-1.33 6.434 6.434 0 0 0-7.913-8.116 24.588 24.588 0 0 0-2.977 1.285 5.35 5.35 0 0 1-3.152.534 4.232 4.232 0 0 0-2.015-.29c-.765.229-1.093 1.037-1.4 1.816a3.08 3.08 0 0 1 1.435 1.082 3.013 3.013 0 0 0-1.854-.075.191.191 0 0 0-.033.009c-.69 1.243-.731 1.547-2.094 1.95z",
    transform: "translate(-480.829 -236.248)",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12697",
    d: "M646.278 304.8c-4.97-.4-9.509 3.4-11.578 7.938s-2.2 9.683-2.305 14.669l-.312 15.5c-.046 2.293-.092 4.587-.207 6.878a33.63 33.63 0 0 1-.837 6.62c-1.013 3.989-3.242 7.543-5.439 11.023a149.051 149.051 0 0 0 17.128 4.091c2.889-9.344 5.811-18.957 5.1-28.712-.376-5.162-1.764-10.2-2.292-15.35-.747-7.292.243-14.638 1.232-21.9",
    transform: "translate(-458.146 -269.742)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12698",
    d: "M684.148 306.845c4.923.792 8.429 5.562 9.362 10.46s-.158 9.93-1.244 14.8l-3.377 15.128c-.5 2.239-1 4.478-1.432 6.73-.421 2.188 1.341 4.994 1.361 7.222.037 4.115-.762 7.5.545 11.406a149.047 149.047 0 0 1-17.609-.094c-.587-9.763-1.143-19.795 1.863-29.1 1.591-4.925 4.136-9.491 5.872-14.367 2.458-6.906 3.24-14.277 4-21.567",
    transform: "translate(-483.952 -270.911)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12699",
    d: "M707.891 433.311a2.82 2.82 0 0 1 .976-3.81 2.71 2.71 0 0 1 .4-.194l-.628-21.375 6.8-1.731-2.593 24.9a2.812 2.812 0 0 1-1.231 3.2 2.691 2.691 0 0 1-3.69-.933z",
    transform: "translate(-504.412 -327.027)",
    style: {
      fill: "#ffb6b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12700",
    d: "M705.512 325.163s4.747-4.014 8.741 4.012 1.762 26.363 1.2 27.342-.905-.385-.6 2.224c.25 2.122-1.239 1.856-.7 2.309 1.409 1.194-2.536 1.33-.51 2.382s-7.041 1.249-7.041 1.249-1.1-.783-.335-3.736c.428-1.659 1.5-2.266.356-3.033s1.18-3.141 1.182-3.661-3.621-11.909-3.621-11.909z",
    transform: "translate(-502.529 -280.69)",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12701",
    d: "M581.138 456.536a8 8 0 0 1-6.4-3.2l-19.617-26.156a8 8 0 1 1 12.8-9.6l12.834 17.111 32.962-49.443a8 8 0 1 1 13.31 8.874l-39.234 58.85a8 8 0 0 1-6.433 3.559z",
    transform: "translate(-417.437 -313.181)",
    style: {
      fill: "#86c232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12702",
    d: "M643.5 424.292a2.82 2.82 0 0 0-.764-3.859 2.711 2.711 0 0 0-.391-.216l1.808-21.308-6.694-2.1 1.213 25.008a2.812 2.812 0 0 0 1.052 3.268 2.691 2.691 0 0 0 3.736-.728z",
    transform: "translate(-464.841 -321.72)",
    style: {
      fill: "#ffb6b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12703",
    d: "M644.5 316.8s-4.518-4.271-8.95 3.523-3.217 26.226-2.709 27.234.925-.334.474 2.254c-.367 2.1 1.134 1.922.576 2.344-1.472 1.114 2.458 1.468.378 2.406s6.961 1.636 6.961 1.636 1.138-.721.541-3.712c-.335-1.68-1.371-2.345-.188-3.048s-1-3.2-.977-3.721 4.274-11.69 4.274-11.69z",
    transform: "translate(-461.931 -275.874)",
    style: {
      fill: "#3f3d56"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorTerms);
export default __webpack_public_path__ + "static/media/VendorTerms.47ecac3cdfb1fc765a12fd9e2d6ef55c.svg";
export { ForwardRef as ReactComponent };